import { RichSelect } from 'common-front/src/designSystem/form/richSelect';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { WorkflowTrigger } from 'common/src/generated/types';
import * as React from 'react';
import { WorkflowBox } from '../workflowBox';

interface IWorkflowTriggerStepProps {
    isEdit: boolean;
}

export const WorkflowTriggerStep = (props: IWorkflowTriggerStepProps) => {
    const { translate } = useHeavent();

    return (
        <WorkflowBox
            category={translate('initialisation_38640')}
            icon="hand-sparkles"
            title={translate('quand_le_membre_51578')}
        >
            <RichSelect
                isSearchVisible={true}
                name="workflow.trigger"
                placeholder={translate('choisir_un_d_cl_85012')}
                state={props.isEdit ? 'disabled' : 'active'}
            >
                <option value={WorkflowTrigger.Assigned}>{translate('est_affect_93543')}</option>
                <option value={WorkflowTrigger.VolunteersSegment}>
                    {translate('VolunteersSegment')}
                </option>
            </RichSelect>
        </WorkflowBox>
    );
};
